export const swiperDefaults = {
    pagination: {
        el: '.slider-pagination',
        type: 'bullets',
        bulletClass: 'slider-pagination__item',
        bulletActiveClass: 'slider-pagination__item--active',
        clickable: true
    },
    navigation: {
        nextEl: '.slider-navigation__next',
        prevEl: '.slider-navigation__prev',
        hiddenClass: 'slider-navigation--hidden',
        disabledClass: 'slider-navigation--disabled'
    }
}
